/** Token authorization purposes the UI has labels for; others show their raw id. */
export const AUTHORIZATION_PURPOSES = ["data_sync", "scheduled_flows", "micro_app_data"] as const;
export type AuthorizationPurpose = (typeof AUTHORIZATION_PURPOSES)[number];

export const isAuthorizationPurpose = (purpose: string): purpose is AuthorizationPurpose =>
  (AUTHORIZATION_PURPOSES as readonly string[]).includes(purpose);

interface ReauthCheckable {
  isValid: boolean;
  syncTargets?: Array<{ reauthorizationRequired?: boolean }> | null;
}

/** An authorization needs re-authorizing when its token is invalid or any data source says so. */
export const needsReauth = (grant: ReauthCheckable) =>
  !grant.isValid || (grant.syncTargets ?? []).some((target) => target.reauthorizationRequired);
